import axios from "axios";
import WriteToLog from "./WriteToLog";

/**
 * Get Condition.Search (Problems) (R4) data from EHR
 * @param {*} patID 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getConditionProblems(patFHIRID, fhir_server, access_token) {
  var category = "problem-list-item";
  var clinicalStatus = "active";
  let floValue = "";
  const conditionsObj = {};
  const icd10Codes = [];

  const ehrconfig = await axios.get('ehrconfig.json');
  const EHR_DIFFICULT_AIRWAY_ICD_CODES = ehrconfig.data["EHR_DIFFICULT_AIRWAY_ICD_CODES"];
  const EHR_CSPINE_INSTABILITY_ICD_CODE = ehrconfig.data["EHR_CSPINE_INSTABILITY_ICD_CODE"];
  const EHR_CSPINE_INJURY_ICD_CODE = ehrconfig.data["EHR_CSPINE_INJURY_ICD_CODE"];
  let conditionSearchUrl = ehrconfig.data["EHR_CONDITION_SEARCH_R4"];

  let getConditionProblemsUrl = fhir_server + conditionSearchUrl + '?category=' + category + '&patient=' + patFHIRID + '&clinical-status=' + clinicalStatus;

  try {
    let response = await axios.get(
      getConditionProblemsUrl,
      {
        headers:
        {
          'Authorization': 'Bearer ' + access_token,
          'Accept': 'application/json'
        }
      });
    //WriteToLog("getConditionProblems Condition.Search (R4) FHIR response: " + JSON.stringify(response.data));
    if (response.data.total > 0) {
      let entryArray = response.data.entry;
      for (var i= 0; i < entryArray.length; i++) {
        if (entryArray[i].resource !== undefined) {
          let resourceType = entryArray[i].resource.resourceType;
          if (resourceType === "Condition" && entryArray[i].resource.code !== undefined) {
            //let text = entryArray[i].resource.code.text;
            //console.log("Problem: " + text);
            //let condition = {};
            if (entryArray[i].resource.code.coding !== undefined) {
              for (const element of entryArray[i].resource.code.coding) {
                if (element.system.endsWith("icd-10-cm")) {
                  //condition.Problem = text;
                  //condition.ICD10 = element.code;
                  icd10Codes.push(element.code);
                  //condition.OnsetDateTime = entryArray[i].resource.onsetDateTime;
                  //console.log("abatementDateTime: " + entryArray[i].resource.abatementDateTime);
                  //console.log("recordedDate: " + entryArray[i].resource.recordedDate);
                  if (element.code) {
                    if (EHR_DIFFICULT_AIRWAY_ICD_CODES.includes(element.code)) {
                      conditionsObj["DifficultAirway"] = "yes";
                    }
                    if (element.code.startsWith(EHR_CSPINE_INJURY_ICD_CODE)) {
                      conditionsObj["CSpineInjury"] = "yes";
                    }
                    if (EHR_CSPINE_INSTABILITY_ICD_CODE.includes(element.code)) {
                      conditionsObj["CSpineInstability"] = "yes";
                    }
                  }
                }
              }
            } 
          } // end of if Condition
        }
      }
      conditionsObj["Conditions"] = icd10Codes;
      return conditionsObj;
    } else {
      //ehr value empty if total is 0
      let entryArray = response.data.entry;
      for (var j = 0; j < entryArray.length; j++) {
        if (entryArray[j].resource !== undefined) {
          let resourceType = entryArray[j].resource.resourceType;
          if (resourceType === "OperationOutcome" && entryArray[j].resource.issue !== undefined) {
            let issueArray = entryArray[j].resource.issue;
            if (issueArray.length > 0) {
              if (entryArray[j].resource.issue[0].diagnostics !== undefined)
              {
                floValue = "Error: " + entryArray[j].resource.issue[0].diagnostics;
              } else {
                floValue = entryArray[j].resource.issue[0].details.text;
              }
            }
          }
        }
      }
      return floValue;
    }
  } catch (error) {
    if (!error.message.includes("401")) { // 401 - Access Token Expired
      WriteToLog("getConditionProblems Condition.Search FHIR error: " + error.message);
    }
    return error.message;
  }
}

export default getConditionProblems;
